import React,{useRef,useState} from 'react';
import API from '../api';
import './CampaignCalendarPanel.css';

const message=error=>error?.response?.data?.message||error?.response?.data?.error||error?.message||'The settlement could not be saved. Try again.';
const title=value=>value.charAt(0).toUpperCase()+value.slice(1);

export default function CampaignSettlementPanel({campaign,api=API}){
 const [context,setContext]=useState(null),[open,setOpen]=useState(false),[busy,setBusy]=useState(false),[error,setError]=useState(''),[saved,setSaved]=useState(null);
 const [choices,setChoices]=useState({size:'hamlet',environment:'river',population:'50',district_count:'1'});
 const pending=useRef(null),base='/v1/veridian/campaigns/'+encodeURIComponent(campaign.campaign_id)+'/settlement';
 async function load(){const response=await api.get(base);setContext(response.data);}
 async function show(){setOpen(true);setBusy(true);setError('');try{await load();}catch(error){setError(message(error));}finally{setBusy(false);}}
 function edit(key,value){
  pending.current=null;setSaved(null);setError('');
  setChoices(previous=>{
   if(key==='size'){const range=context.choices.ranges[value];return {...previous,size:value,population:String(range[0]),district_count:String(range[2])};}
   return {...previous,[key]:value};
  });
 }
 async function save(){
  setBusy(true);setError('');
  try{
   if(!pending.current){
    const selected={...choices,population:Number(choices.population),district_count:Number(choices.district_count)};
    if(!Number.isSafeInteger(selected.population)||!Number.isSafeInteger(selected.district_count)||choices.population===''||choices.district_count==='')
     throw Error('Enter a whole population and district count.');
    const range=context.choices.ranges[selected.size];
    if(selected.population<range[0]||selected.population>range[1]||selected.district_count<range[2]||selected.district_count>range[3])
     throw Error('Choose a population and district count within the displayed ranges.');
    pending.current={action_key:window.crypto.randomUUID(),expected_account_version:context.account_version,
     expected_campaign_version:context.campaign_version,source_package_sha256:context.source_package_sha256,choices:selected};
   }
   const result=await api.post(base,pending.current);pending.current=null;setSaved(result.data.outputs);
   await load().catch(()=>setError('Your settlement blueprint was saved. Reload this page to refresh it.'));
  }catch(error){setError(message(error));if(error.response?.status>=400&&error.response?.status<500){pending.current=null;await load().catch(()=>{});}}
  finally{setBusy(false);}
 }
 const range=context?.choices.ranges[choices.size];
 return <div className="vd-calendar" role="group" aria-label={'Settlement for '+campaign.name}>
  <button type="button" disabled={busy} onClick={show}>Settlement for {campaign.name}</button>
  {open&&<><h4>Starter settlement blueprint</h4>
   {error&&<p role="alert">{error}</p>}
   {saved&&<p role="status">{saved.name} blueprint saved. World time has not advanced.</p>}
   {context?.settlement&&<p>{context.settlement.name} · {title(context.settlement.size)} · {context.settlement.population} residents · {context.settlement.district_count} district{context.settlement.district_count===1?'':'s'}</p>}
   {context&&!context.settlement&&!saved&&context.status==='DRAFT'&&<>
    {!context.calendar_configured?<p>Save this campaign’s starting calendar date first, then reopen settlement setup.</p>:<>
     <p>Choose a setting for the starter settlement. Its blueprint records a place to develop during world setup.</p>
     <fieldset disabled={busy}><legend>Settlement choices</legend>
      <label>Settlement size<select aria-label="Settlement size" value={choices.size} onChange={event=>edit('size',event.target.value)}>
       {Object.keys(context.choices.ranges).map(size=><option key={size} value={size}>{title(size)}</option>)}</select></label>
      <label>Environment<select aria-label="Settlement environment" value={choices.environment} onChange={event=>edit('environment',event.target.value)}>
       {context.choices.environments.map(value=><option key={value} value={value}>{title(value)}</option>)}</select></label>
      <label>Population ({range[0]}–{range[1]})<input aria-label="Settlement population" type="number" min={range[0]} max={range[1]} value={choices.population} onChange={event=>edit('population',event.target.value)}/></label>
      <label>Districts ({range[2]}–{range[3]})<input aria-label="Settlement districts" type="number" min={range[2]} max={range[3]} value={choices.district_count} onChange={event=>edit('district_count',event.target.value)}/></label>
     </fieldset><button type="button" disabled={busy} onClick={save}>{busy?'Saving settlement…':'Save settlement blueprint'}</button>
    </>}
   </>}
   <button type="button" disabled={busy} onClick={()=>setOpen(false)}>Close settlement</button>
  </>}
 </div>;
}
